import $ from 'jquery';
import MarkerClusterer from './markerclusterer';
import matchBreakpoint from 'components/utils/matchBreakpoint';
/**
 * The csr-map does not always require to zoom in when clicking on a cluster.
 * These overrides add the functionality to block the next zoom action on click.
 */

/**
 * Should clustermarkerer zoom when clicking on a cluster?
 *
 * @returns {boolean}
 */
MarkerClusterer.prototype.getZoomOnClick = function() {
  var zoomOnClick = this.zoomOnClick_;
  if (this._disableNextZoomOnClick) {
    zoomOnClick = this._disableNextZoomOnClick = false;
  }

  return zoomOnClick;
};

/**
 * Disables the next zoom on click
 */
MarkerClusterer.prototype.disableNextZoomOnClick = function() {
  this._disableNextZoomOnClick = true;
};

var originalClustererGetBounds = MarkerClusterer.Cluster.prototype.getBounds;

/**
 * Adds a small margin around the bounds to allow big icons to be
 * rendered
 *
 * @returns {google.maps.LatLngBounds}
 */
MarkerClusterer.Cluster.prototype.getBounds = function() {
  var bounds = originalClustererGetBounds.apply(this, arguments);

  if (matchBreakpoint('xsmall')) {
    var southWest = bounds.getSouthWest();
    var northEast = bounds.getNorthEast();
    var southWestLongitude = southWest.lng();
    var southWestLatitude = southWest.lat();
    var northEastLongitude = northEast.lng();
    var northEastLongitudeCorrected =
      northEastLongitude > southWestLongitude ? northEastLongitude : northEastLongitude + 360;
    var northEastLatitude = northEast.lat();

    var $mapDiv = $(this.map_.getDiv());

    var mapWidth = $mapDiv.width();
    var mapHeight = $mapDiv.height();

    var latiduteDifference = northEastLatitude - southWestLatitude;
    var longitudeDifference = northEastLongitudeCorrected - southWestLongitude;

    var latitudeIncreaseFactor = 60 / (mapWidth * 2);
    var latitudeIncrease = latiduteDifference * latitudeIncreaseFactor;

    var longitudeIncreaseFactor = 60 / (mapHeight * 2);
    var longitudeIncrease = longitudeDifference * longitudeIncreaseFactor;

    northEastLatitude += latitudeIncrease;
    southWestLatitude -= latitudeIncrease;
    northEastLongitude += longitudeIncrease;
    southWestLongitude -= longitudeIncrease * 10;

    bounds.extend(new google.maps.LatLng(northEastLatitude, northEastLongitude));

    bounds.extend(new google.maps.LatLng(southWestLatitude, southWestLongitude));
  }

  return bounds;
};

export default MarkerClusterer;
